/*
 * @Date: 2019-08-21 18:04:23
 * @LastEditors: x
 * @LastEditTime: 2023-06-12 16:31:19
 */
import payApi from '../../api/pay'

const actions = {
  sendBuyCertificateInput(context, data) {
    return payApi.sendBuyCertificateInput(data)
  }
}

export default {
  actions
}


// WEBPACK FOOTER //
// ./src/store/modules/pay.js